import React from 'react';

interface ProjectTimeProps {
    startTime: number;
    pausedTime?: number | null;
}

const ProjectTime = ({ startTime, pausedTime = null }: ProjectTimeProps) => {
    const convertTime = React.useCallback(() => {
        const runTime = Math.abs(Math.floor(Date.now() / 1000) - startTime);
        const pad = (num: number) => `0${num}`.slice(-2);
        const seconds = pausedTime ? pausedTime - startTime : runTime;

        const d = Math.floor(seconds / 86400);
        const h = Math.floor((seconds - d * 86400) / 3600);
        const m = Math.floor((seconds - (d * 86400 + h * 3600)) / 60);
        const s = seconds - d * 86400 - h * 3600 - m * 60;

        return `${d} day${d === 1 ? '' : 's'}, ${pad(h)}:${pad(m)}:${pad(s)}`;
    }, [startTime, pausedTime]);

    const [time, setTime] = React.useState(convertTime());

    React.useEffect(() => {
        if (!pausedTime) {
            const interval = setInterval(() => setTime(convertTime()), 1000);
            return () => clearInterval(interval);
        }
    }, [convertTime, pausedTime]);

    return <span>{time}</span>;
};

export default ProjectTime;
